export default function Footer() {
  return (
    <footer id="footer" className="relative w-full bg-foreground-950 text-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="text-xl font-heading font-bold">黑料视频</span>
            <p className="mt-4 text-sm text-foreground-400 leading-relaxed">
              黑料视频是国内领先的国产黑料视频聚合平台，每日更新海量热门黑料视频合集，覆盖91黑料视频、明星八卦、网红追踪、社会热点等多个垂直领域。高清在线观看，免费下载，致力为用户提供最优质的黑料视频内容体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="space-y-2.5">
              {[
                { label: '首页', href: '#hero' },
                { label: '热门话题', href: '#topics' },
                { label: '焦点专题', href: '#carousel' },
                { label: '热度排行', href: '#ranking' },
                { label: '实时快讯', href: '#updates' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="block text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">内容分类</h4>
            <div className="space-y-2.5">
              {[
                '91黑料视频专区',
                '明星八卦爆料',
                '网红追踪报道',
                '社会热点内幕',
                '国产视频合集',
              ].map((item) => (
                <a
                  key={item}
                  href="#index"
                  className="block text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
                >
                  {item}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">合作伙伴</h4>
            <div className="space-y-2.5">
              <p className="text-sm text-foreground-500">更多合作伙伴即将入驻</p>
            </div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mt-6 mb-3">关注我们</h4>
            <div className="flex items-center gap-3">
              {[
                { icon: 'ri-wechat-line', label: '微信' },
                { icon: 'ri-weibo-line', label: '微博' },
                { icon: 'ri-telegram-line', label: 'Telegram' },
              ].map((social) => (
                <span
                  key={social.label}
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-foreground-400 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
                  title={social.label}
                >
                  <i className={`${social.icon} text-base`}></i>
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 黑料视频 版权所有。本站内容仅供个人观看，禁止转载与商业用途。
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="#hero" className="hover:text-background-50 transition-colors cursor-pointer">服务条款</a>
            <a href="#hero" className="hover:text-background-50 transition-colors cursor-pointer">隐私政策</a>
            <a href="#contact" className="hover:text-background-50 transition-colors cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>
    </footer>
  );
}